<!--
  Oprl - souhrnná nástrojová nabídka 
-->
<template>
  <div>
    <MapOt_Oprl class="" :AssetsUrl="AssetsUrl" :ServiceMap="ServiceMap" :MapLegendLayers="MapLegendLayers" :MAP="MAP"
      :MapScale="MapScale" :MapLayerLegend_view="MapLayerLegend_view"
      :MapLayerLegendDynamic_content="MapLayerLegendDynamic_content" :CompList="CompList"
      @MapUserSettingsButtonView="MapUserSettingsButtonView" @MapLegendNewLayer="MapLegendNewLayer"
      @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet" @MapLayerLegendStaticSet="MapLayerLegendStaticSet"
      @MapViewZoomToBounds="MapViewZoomToBounds" @MapViewZoomToMbr="MapViewZoomToMbr"
      @MapViewZoomToScalePoint="MapViewZoomToScalePoint" @MapQueryFeature_GetInfo="MapQueryFeature_GetInfo">
    </MapOt_Oprl>

    <MapOt_Pato class="" :AssetsUrl="AssetsUrl" :ServiceMap="ServiceMap" :MapLegendLayers="MapLegendLayers" :MAP="MAP"
      :MapScale="MapScale" :MapLayerLegend_view="MapLayerLegend_view"
      :MapLayerLegendDynamic_content="MapLayerLegendDynamic_content" :CompList="CompList"
      @MapUserSettingsButtonView="MapUserSettingsButtonView" @MapLegendNewLayer="MapLegendNewLayer"
      @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet" @MapLayerLegendStaticSet="MapLayerLegendStaticSet"
      @MapViewZoomToBounds="MapViewZoomToBounds" @MapViewZoomToMbr="MapViewZoomToMbr"
      @MapViewZoomToScalePoint="MapViewZoomToScalePoint" @MapQueryFeature_GetInfo="MapQueryFeature_GetInfo">
    </MapOt_Pato>
  </div>
</template>

<script>

export default {

  components: {
    // Oprl
    MapOt_Oprl: () => import("./MapOt_Oprl.vue"),
    // Pato
    MapOt_Pato: () => import("./MapOt_Pato.vue"),

  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // webová služba
    ServiceMap: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Legenda k vrstvě
    // Přepínaní zobrazení 
    MapLayerLegend_view: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},
    // Seznam  komponent
    CompList: { type: Array },


  },

  data() {
    return {

    };
  },

  computed: {

  },

  watch: {

  },

  methods: {
    // Viditelnost tlačítka pro dialog s nastavením
    MapUserSettingsButtonView: function (value) {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapUserSettingsButtonView', value);
    },
    // Nová mapová vrstva - volá se funkce v nadřazeném objektu
    MapLegendNewLayer: function (vMapLayerInstr, vMapLayerVisible) {
      this.$emit('MapLegendNewLayer', vMapLayerInstr, vMapLayerVisible);
    },
    // Dynamická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendDynamicSet', layerId, title, content);
    },
    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendStaticSet', layerId, title, content);
    },
    // Změna mapového výřezu podle obdelníku
    MapViewZoomToBounds: function (value) {
      this.$emit('MapViewZoomToBounds', value);
    },
    // Změna mapového výřezu podle obdelníku
    MapViewZoomToMbr: function (value) {
      this.$emit('MapViewZoomToMbr', value);
    },
    // Změna mapového výřezu na cílové měřítko a středový bod
    MapViewZoomToScalePoint: function (vTargetScale, vPoint) {
      this.$emit('MapViewZoomToScalePoint', vTargetScale, vPoint);
    },
    MapQueryFeature_GetInfo: function (feature, layer) {
      this.$emit('MapQueryFeature_GetInfo', feature, layer);
    },

  },

  mounted() {
    // První spuštění nástroje
    // console.log("OPRL multi start");
    // console.log(this.MAP);



  },
};
</script>